import { ExamPage } from './ExamPage';
export default ExamPage;
